import { brandLogo } from "../../utils";

export const LogoOverlay = () => (
  <div className="overlay loading-overlay">{brandLogo}</div>
);
